module.exports = __webpack_public_path__ + "img/card-frame-yellow.e4129b3b.png";